import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import { IGetPolicyPaymentInfoRequest, ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetPolicyPaymentInfo } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetPolicyPaymentInfoApi =
  (endpoint: string): GetPolicyPaymentInfo =>
  async ({ policyNumber, clubCode, appFlow, brokerRegion }: IGetPolicyPaymentInfoRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetPolicyPaymentInfoApi scenario', { scenario });
      LogCannon.blast('GetPolicyPaymentInfoApi start', { endpoint });

      let modifiedEndPoint = clubCode ? `${endpoint}/${policyNumber}/${clubCode}` : `${endpoint}/${policyNumber}`;
      modifiedEndPoint = appFlow ? `${modifiedEndPoint}?appFlow=${appFlow}` : modifiedEndPoint;
      modifiedEndPoint = brokerRegion ? `${modifiedEndPoint}&brokerRegion=${brokerRegion}` : modifiedEndPoint;

      const { data, status } = await axios.get(modifiedEndPoint, createAxiosConfig(scenario, modifiedEndPoint));
      if (data?.error) {
        const { code } = data?.error;
        return Promise.reject({
          code,
          type: ErrorType.SOFT_ERROR,
        });
      }

      LogCannon.blast('GetPolicyPaymentInfoApi success');
      return { ...data, status: status };
    } catch (error: unknown) {
      LogCannon.error('GetPolicyPaymentInfoApi error', error as object);
      const err = error as { message?: string; response?: { status?: number; data?: { pxEvent?: boolean } } };
      const message = err?.message;
      const statusCode = err?.response?.status ?? (message ? parseInt(message.substring(message.length - 3)) || undefined : undefined);

      if (statusCode && statusCode < 500) {
        if (statusCode === 403 && err?.response?.data?.pxEvent) {
          return Promise.reject({ type: ErrorType.BOT_ERROR });
        }
        return Promise.reject({
          message,
          type: ErrorType.SOFT_ERROR,
        });
      }

      return Promise.reject({
        message,
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
